import { BlockWrapper } from '@smartfire/js-block-engine';
import Button from '../../button/block';
import style from './block.module.scss';

const Block = ({ text }) => {
    const handleOpenPopinSignupEvent = () => {
        // Fire the event "openPopinSignup"
        document.dispatchEvent(new CustomEvent('openPopinSignup', { detail: { openModal: true } }));
    };

    return (
        <BlockWrapper.Div className={style.block}>
            <div className={style.text}>{text}</div>

            <Button
                classNames={style.button}
                text="JE FINALISE MON INSCRIPTION"
                onClick={handleOpenPopinSignupEvent}
                aspect="contained"
                position="center"
                backgroundContained={style.green}
                colorContained={style.blue}
                Wrapper="button"
                inspector={false}
            />
        </BlockWrapper.Div>
    );
};

export default Block;
